import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CheckAccountEntity } from '../banking/account-check/models/accountCheck';

type AccountState = {
  data: { accounts?: CheckAccountEntity[]; id?: string };
  loading: boolean;
};

const initialState: AccountState = {
  data: { accounts: undefined, id: undefined },
  loading: false,
};

export const accountCheckSlice = createSlice({
  name: 'account-check',
  initialState,
  reducers: {
    fetchAccountsSuccess: (state, action: PayloadAction<CheckAccountEntity[]>) => {
      state.data.accounts = action.payload;
    },
    createReportStart: (state) => {
      state.loading = true;
    },
    createReportSuccess: (state, action: PayloadAction<string>) => {
      state.data.id = action.payload;
      state.loading = false;
    },
  },
});

export const { fetchAccountsSuccess, createReportSuccess, createReportStart } =
  accountCheckSlice.actions;
